import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { ROUTES } from '@/shared/constants/routes';
import Login from '@features/auth/components/Login';
import CasdoorCallback from '@features/auth/components/CasdoorCallback';
import PricingPage from '@features/pricing/components/PricingPage';
import OrdersPage from '@features/pricing/components/OrdersPage';
import AppContent from './AppContent';

/**
 * Application Routes Configuration
 * All routes are defined here for better maintainability
 */
const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Persian (Farsi) Route - Root */}
      <Route path={ROUTES.HOME} element={<AppContent />} />
      
      {/* English Route */}
      <Route path={ROUTES.HOME_EN} element={<AppContent />} />
      
      {/* Authentication Routes */}
      <Route path={ROUTES.LOGIN} element={<Login />} />
      
      {/* OAuth Callback Route */}
      <Route
        path={ROUTES.CALLBACK}
        element={
          <>
            <Helmet>
              <title>ورود</title>
            </Helmet>
            <CasdoorCallback />
          </>
        }
      />
      
      {/* Pricing Route - Persian */}
      <Route
        path={ROUTES.PRICING}
        element={
          <>
            <Helmet>
              <title>تعرفه و قیمت‌ها - کیوردیاب</title>
            </Helmet>
            <PricingPage />
          </>
        }
      />
      
      {/* Pricing Route - English */}
      <Route
        path={ROUTES.PRICING_EN}
        element={
          <>
            <Helmet>
              <title>Pricing - KeywordYab</title>
            </Helmet>
            <PricingPage />
          </>
        }
      />
      
      {/* Orders Route */}
      <Route
        path={ROUTES.ORDERS}
        element={
          <>
            <Helmet>
              <title>سفارشات من - کیوردیاب</title>
            </Helmet>
            <OrdersPage />
          </>
        }
      />
      
      {/* Catch-all route - Redirect to home */}
      <Route path={ROUTES.NOT_FOUND} element={<Navigate to={ROUTES.HOME} replace />} />
    </Routes>
  );
};

export default AppRoutes;

